<template>
  <div>
    <toggle-details :defaultOpen="true">
      <template slot="header">Uw verbruik</template>
      <template slot="content">
        <p v-html="deliveryDetail.Intro"></p>
        <table>
          <tr v-if="deliveryDetail.Usage[0].LowValue">
            <th class="u-text-align--left" colspan="2">
              <h4>{{deliveryDetail.Usage[0].HighValue}}</h4>
            </th>
            <th class="u-text-align--left" colspan="2">
              <h4>{{deliveryDetail.Usage[0].LowValue}}</h4>
            </th>
          </tr>
          <tr>
            <td v-html="deliveryDetail.Usage[1].Text"></td>
            <td class="pl- u-text-align--right pr" v-html="deliveryDetail.Usage[1].HighValue"></td>
            <td v-if="deliveryDetail.Usage[1].LowValue" v-html="deliveryDetail.Usage[1].Text"></td>
            <td
              v-if="deliveryDetail.Usage[1].LowValue"
              class="pl- u-text-align--right"
              v-html="deliveryDetail.Usage[1].LowValue"
            ></td>
          </tr>
          <tr>
            <td v-html="deliveryDetail.Usage[2].Text"></td>
            <td class="u-text-align--right pr" v-html="deliveryDetail.Usage[2].HighValue"></td>
            <td v-if="deliveryDetail.Usage[2].LowValue" v-html="deliveryDetail.Usage[2].Text"></td>
            <td
              v-if="deliveryDetail.Usage[2].LowValue"
              class="u-text-align--right"
              v-html="deliveryDetail.Usage[2].LowValue"
            ></td>
          </tr>
        </table>
      </template>
    </toggle-details>
  </div>
</template>

<script>
import ToggleDetails from './ToggleDetails';
//import TariffTotalRow from './TariffTotalRow';
//import KeyValueLabel from './KeyValueLabel';
export default {
	props: ['deliveryDetail'],

	components: { /*KeyValueLabel,TariffTotalRow*/ ToggleDetails },
	computed: {
		priceDetail: function() {
			return this.resultItem.PriceDetail;
		}
	}
};
</script>
